module.exports = __webpack_public_path__ + "static/img/envi-shadow.ed3a8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/envi-shadow.png
// module id = X66j
// module chunks = 1